module.exports = __webpack_public_path__ + "static/media/007.e22f2536.jpg";